<template>
  <DataTable
    class="tableHeaderStyle"
    :value="data"
    stripedRows
    tableStyle="min-width: 50rem"
    emptyMessage="You currently have no price control"
    ref="dt"
    :exportFilename="exportFileName"
  >
    <!-- <Column sortable field="depotName" header="Depot Name" /> -->

    <Column sortable field="customerName" header="Customer" />

    <Column sortable field="productName" header="Product">
      <template #body="data">
        <PriceControlProductTags :product="data.data.productName" :qty="''" />
      </template>
    </Column>
    <Column sortable field="price" header="Price">
      <template #body="data">
        {{ amountFormat(data.data.price) }}
      </template>
    </Column>
    <Column sortable field="effectiveDate" header="Date Effected" />
    <Column sortable field="endDate" header="End Date" />
    <Column sortable field="priceControlStatus" header="Status">
      <template #body="data">
        <PaymentStatusType :type="data.data.priceControlStatus" />
        <StatusTag class="" :type="data.data.isUsed" />
      </template>
    </Column>

    <template #empty>
      <div class="pt-4 text-center">
        <EmptyList :type="'Customer Price change log'" />
      </div>
    </template>
  </DataTable>

  <Pagination :paginationData="pagination" :handler="handlePagination" />
  <!-- <PriceChangeLogExemption
    :open="open"
    :close="close"
    :data="data1"
    :getCustomerPriceChangeLog="getCustomerPriceChangeLog"
  /> -->
</template>

<script>
//utils
import { amountFormat, formatNumber, formatDate } from "@/utils/formatter";
// import PriceChangeLogExemption from "@/components/pages/Depot/Drawers/PriceLogExemptions";
//libraries
import Column from "primevue/column";
import DataTable from "primevue/datatable";

//components
import StatusTag from "@/components/UI/Tags/StatusTag";
import PriceControlProductTags from "@/components/UI/StockControlProductsTags";
import ProductType from "@/components/UI/ProductTypes";
import Pagination from "@/components/UI/Pagination/index.vue";
import Button from "@/components/UI/Buttons/DrawerButton.vue";
import PaymentStatusType from "@/components/UI/PaymentStatusTypes";
import EmptyList from "@/components/Empty/index.vue";

export default {
  name: "DepotPriceChangeLog",
  props: [
    "details",
    "data",
    "exportFileName",
    "pagination",
    "handlePagination",
    "getCustomerPriceChangeLog",
  ],
  components: {
    Column,
    DataTable,
    // PriceChangeLogExemption,
    Button,
    Pagination,
    ProductType,
    PaymentStatusType,
    EmptyList,
    StatusTag,
    PriceControlProductTags,
  },
  data() {
    return {
      formatDate,
      open: false,
      amountFormat,
      data1: "",
      formatNumber,
    };
  },
  mounted() {},
  methods: {
    exportTable() {
      this.$refs.dt.exportCSV();
    },
    showDrawer(log) {
      // console.log(log, "is logg");
      this.open = true;
      this.data1 = log;
    },
    close() {
      this.open = false;
    },
  },
};
</script>

<style></style>
